<template>
	<div class="header">
		<div class="top"></div>
		<div class="banner">
			<div class="icon marg">
				<img :src="cdnurl+config.logo_big" />
			</div>
			<div class="marg">
				<div class="users">
					<div>您好、{{userInfos.nickname}}</div>
					<div><img src="../assets/quit.svg" /></div>
					<div @click="logoutCms()">退出</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfos: {
					nickname: '',
				},
				config: {
					logo_big: ''
				},
				cdnurl: this.$cdn
			};
		},
		created() {
			this.config = JSON.parse(sessionStorage.getItem('configs'))
			this.userInfos = JSON.parse(sessionStorage.getItem('userInfo'))
			console.log(this.userInfos)
		},
		methods: {
			// 退出
			logoutCms() {
				this.$confirm('是否继续退出系统?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.showLogout = false
					const loading = this.$loading({
						lock: true,
						text: '正在退出，请稍候...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					})
					setTimeout(() => {
						loading.close()
						sessionStorage.clear()
						this.$message({
							message: '已退出',
							type: 'success'
						})
						this.$router.replace({
							name: 'login'
						})
					}, 2000)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			}
		}
	};
</script>

<style scoped>
	/* 头部 */
	.header {
		width: 100%;
		height: auto;
	}

	.marg {
		width: 1200px;
		margin: 0 auto;
	}

	.header .top {
		/* width: 100%; */
		height: 30px;
		background: rgba(6, 98, 179, 1);
	}

	.header .banner {
		width: 100%;
		height: 141px;
		background-image: url(https://files.gsjtpxzx.com/public/assets/front/image/6.png);
		background-size: 100%;
		height: 141px;
	}

	.header .banner .icon {
		padding-top: 33px;
		height: 84px;
	}

	.header .banner .icon img {
		width: 600px;
		height: auto;
	}

	.header .banner .users {
		float: right;
	}

	.header .banner .users div {
		float: left;
		font-size: 16px;
		font-weight: 400;
		color: #000000;
	}

	.header .banner .users div:nth-child(2) {
		width: 15px;
		height: 20px;
		margin-left: 44px;
	}

	.header .banner .users div:nth-child(2)>img {
		width: 15px;
		height: 20px;
	}

	.header .banner .users div:nth-child(3) {
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		margin-left: 10px;
		cursor: pointer;
	}
</style>
